import React from 'react';
import myData from '../data/lookalike.json';
import EChartLiftCurv from './EChartLiftCurv';
import LiftCurveExplanation from './LiftCurveExplanation';
import { DownloadIcon } from '@heroicons/react/outline';
import CustomerTable from './CustomerTable';

export const ResultDisplay = ({ title, data }) => {
    if (!data) return null;

    let content;
    if (typeof data === 'string' && data.startsWith('<')) {
        // If it looks like HTML, render it dangerously
        content = <div className="prose prose-sm max-w-none " dangerouslySetInnerHTML={{ __html: data }} />;
    } else if (typeof data === 'object') {
        // If it's an object, stringify it (nicely formatted)
        content = <pre className="text-xs bg-gray-100  p-2 rounded overflow-x-auto">{JSON.stringify(data, null, 2)}</pre>;
    } else {
        // Otherwise, display as is
        content = <div className="text-sm text-gray-700" dangerouslySetInnerHTML={{ __html: data }} />;
    }

    return (
        <div className="mt-4 p-4 border border-gray-200  rounded-lg bg-gray-50 ">
            <h4 className="font-semibold text-md mb-2 text-gray-800 ">{title}</h4>
            {content}
        </div>
    );
};

const CompLookalike = () => {

    const primaryButtonClass = "px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#0062cc] hover:bg-[#0052ac] disabled:opacity-50 disabled:cursor-not-allowed";

    let parsedLiftData = [];

    if (myData) {
        // --- Display Prediction Results --- 
        const stats = myData.segment_stats;
        const metrics = myData.metrics?.test_metrics;
        const liftMetrics = myData.lift_metrics;
        const preview = myData.preview_data;

        // --- Parse lift data --- 

        if (liftMetrics?.lift_values) {
            try {
                const rawLiftData = JSON.parse(liftMetrics.lift_values);
                // Transform into array of objects for recharts
                if (rawLiftData.index && rawLiftData['Lift (Total Sales)'] && rawLiftData['Cumulative Lift']) {
                    parsedLiftData = rawLiftData.index.map((idx, i) => ({
                        index: idx,
                        'Lift (Total Sales)': rawLiftData['Lift (Total Sales)'][i] || 0,
                        'Cumulative Lift': rawLiftData['Cumulative Lift'][i] || 0,
                    }));
                }
            } catch (parseError) {
                console.error("Error parsing lift_values JSON:", parseError);
            }
        }
        // --- End Parse lift data --- 
    }



    return (
        <div>

            {(myData?.lift_curve_explanation /* Keep condition for layout */) && (
                <div className="mt-4 p-4 border border-gray-200  rounded-lg  ">
                    <h4 className="font-semibold text-md mb-3 text-gray-800 dark:text-white ">Lift Curve Analysis</h4>
                    {parsedLiftData.length > 0 ? (
                        // <LiftCurveChart data={parsedLiftData} />
                        <EChartLiftCurv data={parsedLiftData} />
                    ) : (
                        <p className="text-sm text-center text-gray-500  py-4">Could not load lift curve data.</p>
                    )}

                    {/* --- Render the new Explanation component --- */}
                    <div className="mt-4">
                        <LiftCurveExplanation />
                    </div>
                    {/* --- End new component rendering --- */}
                </div>
            )}

            <CustomerTable />

            {/* {myData?.preview_data && (
                <ResultDisplay title={`Sample Predictions (Showing ${myData?.preview_data.summary?.total_samples || 'some'} customers)`} data={myData?.preview_data.preview_html} />
            )} */}



            {/* Download Button */}
            {/* {myData?.predictions_path && (
                <div className="mt-6 text-center">
                    <a
                        href={myData?.predictions_path}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`${primaryButtonClass} inline-flex items-center`}
                    >
                        <DownloadIcon className="w-5 h-5 mr-2" />
                        Download Full Predictions (.csv)
                    </a>
                </div>
            )} */}

        </div>

    )
}

export default CompLookalike;